import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import SigningFlowWizard from "../components/SigningFlowWizard";
import { getAgreement } from "../lib/agreements";
import { Loader } from "lucide-react";

/**
 * AgreementSigning Page
 *
 * Standalone page for agreement signing via shareable link
 * - Redirects to login if not authenticated
 * - Shows 2-step signing flow if authenticated
 * - Accessible via: /agreements/{agreement_id}/sign
 */
function AgreementSigning() {
  const { agreement_id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  // Needed up front (not just on completion) so the pay-then-sign flow can store it
  // before redirecting to Cashfree and resume correctly on return.
  const [rentalId, setRentalId] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const agreementData = await getAgreement(agreement_id);
        setRentalId(agreementData?.rental_id || null);
      } catch (err) {
        console.error("Error fetching agreement:", err);
      }
    })();
  }, [agreement_id]);

  const handleSigningComplete = () => {
    navigate(rentalId ? `/app/rental/${rentalId}` : "/app");
  };

  // Render signing wizard - it handles its own loading/error states
  return (
    <div className="min-h-screen bg-gray-900 py-8 px-4">
      <SigningFlowWizard
        agreementId={agreement_id}
        rentalId={rentalId}
        userRole={user?.role}
        userName={user?.name}
        onSigningComplete={handleSigningComplete}
        onCancel={() => navigate("/app")}
      />
    </div>
  );
}

export default AgreementSigning;
